enum DECODING {
  AUTO = "auto",
  ASYNC = "async",
  SYNC = "sync"
}

enum FETCHPRIORITY {
  AUTO = "auto",
  HIGH = "high",
  LOW = "low"
}
enum LOADING {
  EAGER = "eager",
  LAZY = "lazy"
}

export { DECODING, FETCHPRIORITY, LOADING };
